import { combineReducers } from 'redux';
import agencies from './agencies';
import filters from './filters';

export default combineReducers({ agencies, filters });
